import controller from './query-builder-node-name.controller';
import template from './query-builder-node-name.html';
import './query-builder-node-name.scss';

export default {
	controller,
	template,
	bindings: {
		node: '<',
	},
	require: {
		builderChildren: '^queryBuilderChildren',
	},
};
